import { render, staticRenderFns } from "./AttributeModal.vue?vue&type=template&id=a3f5fe18&"
import script from "./AttributeModal.vue?vue&type=script&lang=js&"
export * from "./AttributeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports